export const USER_ROLE = {
  CALLER: 'Caller',
  MANAGER: 'Manager',
  ADMIN: 'Admin',
};
